import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { ResetPassword } from '../../../core';
import { AccountService } from '../../account.service';

export class ResetPasswordController {

    public static $inject = [ '$state', '$location', '$timeout', 'accountService', 'notificationService', '$translate', 'enumService', 'siteRetailerHomeUrl'];

    public password: string;
    public confirmPassword: string;
    public errorPassword: string;
    public errorConfirmPassword: string;
    public waiting: boolean;
    public submitted: boolean;
    public resetPasswordForm: ng.IFormController;
    private id: number;
    private passwordKey: string;

    constructor(
        private $state: StateService,
        private $location: ng.ILocationService,
        private $timeout: ng.ITimeoutService,
        private accountService: AccountService,
        private notificationService: NotificationService,
        private $translate: angular.translate.ITranslateService,
        private enumService: EnumService,
        private siteRetailerHomeUrl: string
    ) {
        this.waiting = false;
        this.id = this.$state.params.id;
        this.passwordKey = this.$state.params.key;
        if (this.id === null || this.passwordKey === null) {
            $location.path('/');
        }
    }

    public submit = async () => {
        this.submitted = true;

        if (this.resetPasswordForm.$invalid) {
            this.showErrorForm();
            return;
        }

        this.notificationService.showWaitingMessage();
        this.waiting = true;
        const model: ResetPassword = {
            ID: this.id,
            PasswordKey: this.passwordKey,
            NewPassword: this.password,
            ConfirmPassword: this.confirmPassword
        };

        try {
            const reset = await this.accountService.resetPassword(model);

            this.notificationService.showSuccessMessage({
                title: this.$translate.instant('password_changed'),
                body: this.$translate.instant('redirect_to_login_page'),
                timeout: 3000
            });

            this.$timeout(() => {
                if (reset.Permission === this.enumService.RetailerPermission.Nfrn) {
                    window.open(`${this.siteRetailerHomeUrl}/login`, '_self');
                } else {
                    this.$state.go('account.login');
                }
            }, 3000);

        } catch (error) {
            this.notificationService.showErrorMessage(error);
            this.waiting = false;
            return;
        }
        this.waiting = false;
    }

    private showErrorForm(): void {
        if (this.resetPasswordForm.password.$error) {
            if (this.resetPasswordForm.password.$error.required) {
                this.errorPassword = this.$translate.instant('password_is_required');
            } else if (this.resetPasswordForm.password.$error.maxlength) {
                this.errorPassword = this.$translate.instant('password_must_be_less_20');
            } else if (this.resetPasswordForm.password.$error.minlength) {
                this.errorPassword = this.$translate.instant('password_must_be_atleast_8');
            } else {
                this.errorPassword = this.$translate.instant('password_isnt_valid');
            }

            if (this.resetPasswordForm.confirmPassword.$error) {
                if (this.resetPasswordForm.confirmPassword.$error.match) {
                    this.errorConfirmPassword = this.$translate.instant('passwords_dont_match');
                } else if (this.resetPasswordForm.confirmPassword.$error.required) {
                    this.errorConfirmPassword = this.$translate.instant('type_confirmation_password');
                } else {
                    this.errorConfirmPassword = this.$translate.instant('password_isnt_valid');
                }
            }
        }
    }
}

angular.module('naut')
    .component('resetPassword', {
        template: require('./resetPassword.html'),
        controller: ResetPasswordController,
        controllerAs: 'ctrl'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/components/resetPassword/resetPassword.component.ts